import React from "react";
import { useSelector } from "react-redux";

const Header: React.FC<{ hlanguage: any,allImagesLink?:any}> = ({ hlanguage,allImagesLink}) => {
  // const hlanguage = useSelector((state: any) => state.auth.homeLanguage);
const headerBg = allImagesLink?.header?.find(
  (item: any) => item?.fileName?.includes("home_header.png")
);

const base_Url = process.env.REACT_APP_BASE_URL;
 

  return (
    <>
      <style>
        {`
        .gov-header {
          height: 120px;
          width: 100%;
          display: flex;
          position: relative;
          overflow: hidden;
          background: white;
        }

        /* LEFT WHITE AREA */
        .gov-left {
          flex: 1;
          display: flex;
          align-items: center;
          padding-left: 40px;
          background: white;
          z-index: 2;
        }

        /* RIGHT IMAGE */
        .gov-right {
          flex: 1;
          background-repeat: no-repeat;
          background-position: center right;
          background-size: cover;
          position: relative;
        }

        /* CURVE CUT */
        .gov-right::before {
          content: "";
          position: absolute;
          left: -10px;
          top: 0;
          width: 180px;
          height: 100%;
          background: white;
          border-radius: 0 0% 100% 0;
        }
        .gov-logo {
          height: 90px;
          width: 90px;              /* 🔥 Force equal width */
          object-fit: contain;     /* Keeps full logo visible */
          
        }


        .gov-title {
          font-size: 24px;
          font-weight: 700;
          line-height: 1.2;
          color: #1a1a1a;
        }

        .gov-subtitle {
          font-size: 13px;
          color: #444;
        }

        .gov-menu span {
          display: block;
          height: 3px;
          background: #000;
          margin-bottom: 6px;
          border-radius: 4px;
        }

        /* MOBILE */
        /* ---------------- TABLET / MID SCREENS ---------------- */
@media (max-width: 1000px) and (min-width: 601px) {

  .gov-header {
    height: 110px;
  }

  .gov-left {
    padding-left: 20px;
  }

  .gov-logo {
    height: 46px;
    width: 46px;
  }

  .gov-title {
    font-size: 18px;
  }

  .gov-subtitle {
    font-size: 12px;
  }

  .gov-right {
    flex: 1;
    background-size: auto 100%;
    background-position: right center;
  }
  //    .gov-right::before {
  //   width: 120px;       /* slimmer curve */
  //   left: -60px;
  //   border-radius: 0 0 80% 0;
  // }
}

        @media (max-width: 600px) {

  .gov-header {
    height: auto;
    flex-direction: column;
  }

  .gov-left,
  .gov-right {
    width: 100%;
    flex: none;
  }

  .gov-right {
  display: none;
    height: 80px;
    background-size: cover;
    background-position: center;
  }

  .gov-right::before {
    display: none;
  }

  .gov-logo {
    height: 34px;
    width: 34px;
    display: flex;
    
  }

  .gov-title {
    font-size: 14px;
  }

  .gov-subtitle {
    font-size: 11px;
  }

  .gov-left {
    padding: 8px 12px;
  }

  .gov-logo-wrap {
    
    gap: 6px;
  }
}


        `}
      </style>

      <header className="gov-header"id="home">
        {/* LEFT */}
        <div className="gov-left container-fluid">
          <div className="row align-items-center w-100">
            <div className="col-auto gov-logo-wrap d-flex">
              <img   
              src={`${base_Url}${
                allImagesLink?.header?.find(
                  (item: any) => item?.fileName?.includes("emblem.png")
                )?.fileUrl
              }`} 
            className="gov-logo" />
              <img 
                src={`${base_Url}${
                  allImagesLink?.header?.find(
                    (item: any) => item?.fileName?.includes("GAPMC.png")
                  )?.fileUrl
                }`} 
                className="gov-logo"
               />
            </div>

            <div className="col">
              <h1 className="gov-title mb-1">{hlanguage.g1}</h1>
              <h1 className="gov-title mb-1">{hlanguage.g11}</h1>
              <p className="gov-subtitle mb-0">
                {hlanguage.doa} | {hlanguage.goi}
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        {/* <div className="gov-right"></div> */}
        <div
          className="gov-right"
          style={{
            backgroundImage: headerBg
              ? `url(${base_Url}${headerBg.fileUrl})`
              : "none"
          }} >
        </div>

      </header>
    </>
  );
};

export default Header;
